import ContactPanel from "./contact.js"

export default ContactPanel
